import { ShortcutHint } from '@/src/renderer/components/ui/ShortcutHint'
import './KeysHint.scss'

export interface KeysHintItem {
  /** Die Tasten, nebeneinander: ein Zeichen („←“), ein Kürzel („⌥→“) oder ein Wort („Leertaste“). */
  keys: string[]
  /** Was sie tun, klein geschrieben („auswählen“). */
  label: string
}

export interface KeysHintProps {
  items: KeysHintItem[]
  /** Mittig unter Karten (Setup) oder bündig links unter einer Liste (Checkliste). */
  align?: 'center' | 'start'
  className?: string
}

/**
 * **Eine Leiste mit Tasten und was sie tun** — wo die Tastatur mehr kann, als man sieht: die
 * Auswahl-Karten im Setup (#147), die Checkliste einer Aufgabe (#181). Ein Zeichen steht im
 * schmalen Plättchen, ein Kürzel oder Wort im breiten.
 *
 * @example
 * <KeysHint items={[{ keys: ['←', '→'], label: 'auswählen' }, { keys: ['↵'], label: 'weiter' }]} />
 */
export function KeysHint({ items, align = 'center', className }: KeysHintProps) {
  return (
    <p className={['keys-hint', `keys-hint--${align}`, className].filter(Boolean).join(' ')}>
      {items.map(item => (
        <span key={item.label} className="keys-hint__item">
          {item.keys.map(key => (
            <ShortcutHint key={key} className={[...key].length > 1 ? 'keys-hint__word' : undefined}>{key}</ShortcutHint>
          ))}
          <span>{item.label}</span>
        </span>
      ))}
    </p>
  )
}
